import React from 'react'
import { Link } from 'gatsby'
import { Layout, SectionTitle, Showcase, Header } from '../../../../components'

import './style.scss'
import data from './data.json'

export default () => {
  return (
    <>
      <Header
        site={data.site}
        slug={data.slug + '/develop/'}
        state="develop"
        title={data.title}
      />
      <Layout
        complete={true}
        description={data.description}
        site={data.site}
        slug={data.slug + '/develop/'}
        state="develop"
        title={data.title}
      >
        <SectionTitle>Variants</SectionTitle>

        <p>
          Use the link component only with{' '}
          <span class="inline__code">{'<a>'}</span> elements.
        </p>
        <p className="c-text-content-caption--subtle">
          Please note that the default Link component will have a fixed font
          size. If you need it to inherit the parent's font size, please use the{' '}
          <code>.c-link--inherit</code> variation.
        </p>

        <Showcase
          site={data.site}
          title="Link"
          text="	In addition to the default state, links also have a hover state and a focus state. All states allow the user to recognize that they can use the link to take action."
          code={code.link}
        >
          <a href="/#" class="c-link u-type--center">
            Go back
          </a>
        </Showcase>
        <Showcase
          site={data.site}
          title="Icon Link"
          text={
            <div>
              <p>
                Text links can appear with associated icons, such as the
                question mark on help links or the map pin on location links.
                The icon is interactive and forms part of the navigation. It
                will have the same states as a text link. Refer to our{' '}
                <Link
                  class="link"
                  to={'/' + data.site + '/guidelines/iconography/design'}
                >
                  icon library
                </Link>{' '}
                for available icons.
              </p>
              {/* <p>
                Icon links are available in three different sizes. Change the
                modifier to adjust the size of the link, i.e.{' '}
                <span class="inline__code">c-icon-link--small</span>,{' '}
                <span class="inline__code">--medium</span>, or{' '}
                <span class="inline__code">--large</span>.
              </p> */}
            </div>
          }
          code={code.iconLink}
        >
          <a href="/#" class="c-icon-link">
            <i class="icon icon--question c-icon-link__icon"></i>Learn more
          </a>
        </Showcase>
      </Layout>
    </>
  )
}

export const code = {
  link: `<a href="" class="c-link">Click Here</a>
`,
  iconLink: `<a href="" class="c-icon-link--small">
  <i class="icon icon--question c-icon-link__icon"></i>
  Link Text
</a>
`,
}
